<template>
  <div class="flexi-container page__internal page__not-found">
    <flexi-top-card
      :class="!showHeader ? 'scrolled-up-card' : ''"
      v-view="inView"
      v-if="inputData.homePage"
      :inputData="inputData.homePage.top_card"
      @button-clicked="smoothScroll"
    >
      <template v-slot:title>
        <h1 class="top-card__title">
          <span class="top-card__title-item" v-text="'Page not found'" />
        </h1>
      </template>
      <template v-slot:subTitle>
        <br />
      </template>
      <template v-slot:button>
        <div class="btn-wrapper">
          <button
            @click="redirectToHome"
            class="btn"
            v-text="'Back to home page'"
          />
        </div>
      </template>
    </flexi-top-card>

    <flexi-visible when-hidden="#top-card">
      <a @click.prevent="scroll('#app')">
        <div class="arrow-down">
          <span class="text" v-text="'Go to top'"></span>
          <div class="svg"></div>
        </div>
      </a>
    </flexi-visible>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "page-not-found",
  mounted() {
    window.scrollTo(0, 5);
  },
  computed: {
    ...mapGetters(["inputData"])
  },
  methods: {
    redirectToHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
// @import "~@schnapsterdog/flexi-vue/src/assets/scss/parts/_media-mixins";
</style>
